import recycleDetail from "./components/recycle-detail";

(function ($) {
    recycleDetail();
}(jQuery));